export default __webpack_public_path__ + "static/media/gallery_13.93e907d1.jpg";